import { GenericStyleModel } from '../../Styles/models/generic-style.model';
import { StyleStateEnum } from '../enums/style-state.enum';
import { PaddingModel } from './padding.model';
import { VerticalAlignmentEnum } from '../../Forms/enums/vertical-alignment.enum';
import _ from 'underscore';


export class CuratorStyle extends GenericStyleModel {

    declare styleState: number | string;
    declare displayStyleState: number | string;

    width: string[];
    backgroundColor: string;
    verticalAlignment: VerticalAlignmentEnum;
    padding: PaddingModel;

    constructor(apiModel?: any) {
        super(apiModel);
        if (apiModel) {
            this.setFromApiModel(apiModel);
        }

        if (!this.styleState) {
            this.styleState = StyleStateEnum.DEFAULT;
        }

        if (!this.displayStyleState) {
            this.displayStyleState = this.styleState;
        }

        if (!this.backgroundColor) {
            this.backgroundColor = '#FFFFFF';
        }

        if (!this.verticalAlignment) {
            this.verticalAlignment = VerticalAlignmentEnum.TOP;
        }

        if (!this.padding) {
            this.padding = new PaddingModel();
        }

        if (!this.columnSpacing && this.columnSpacing !== 0) {
            this.columnSpacing = 10;
        }
    }

    clone(): CuratorStyle {
        const clone = new CuratorStyle({
            styleState: this.styleState,
            displayStyleState: this.displayStyleState,
            ...this.getCuratorStyles()
        });

        if (this.template) {
            clone.template = this.template.clone();
        }

        return clone;
    }

    equals(other: CuratorStyle, compareTemplate: boolean): boolean {
        if (!other) {
            return false;
        }

        // If they're both saved styles we don't need to look further
        // @HACK This if condition is complicated because clone isn't used in all places, some use JSON.parse(JSON.stringify(, but it's complicated to update
        // that so for now if other doesn't have isSavedStyle, just check to see that other.styleState is a number, which is equivalent
        if (
            this.isSavedStyle() &&
            (
                (
                    other.hasOwnProperty('isSavedStyle') &&
                    other.isSavedStyle()
                ) ||
                !!Number(other.styleState)
            )
        ) {
            return this.styleState === other.styleState;
        }

        if (!super.equals(other, compareTemplate)) {
            return false;
        }

        if (this.displayRatio !== other.displayRatio) {
            return false;
        }

        if (!_.isEqual(this.width, other.width)) {
            return false;
        }

        if (this.backgroundColor !== other.backgroundColor) {
            return false;
        }

        if (this.verticalAlignment !== other.verticalAlignment) {
            return false;
        }

        if (!this.padding.equals(other.padding)){
            return false;
        }


        return true;
    }

    setFromApiModel(apiModel: any): void {
        super.setFromApiModel(apiModel);

        if (typeof apiModel === 'string') {
            apiModel = JSON.parse(apiModel);
        }

        this.width = ['100%'];
        if (apiModel.hasOwnProperty('displayRatio')) {
            this.displayRatio = apiModel.displayRatio;
        }
        if (apiModel.hasOwnProperty('width')) {
            this.width = apiModel.width;
        }

        if (apiModel.hasOwnProperty('backgroundColor')) {
            this.backgroundColor = apiModel.backgroundColor;
        }

        if (apiModel.hasOwnProperty('verticalAlignment')) {
            this.verticalAlignment = apiModel.verticalAlignment;
        }

        if (apiModel.hasOwnProperty('padding')) {
            this.padding = new PaddingModel(apiModel.padding.paddingAll, apiModel.padding.paddingOption, apiModel.padding.topPadding,
                apiModel.padding.leftPadding, apiModel.padding.bottomPadding, apiModel.padding.rightPadding);
        }
    }

    toBlockStyle(): any {
        if (!this.isSavedStyle()) {
            return {
                ...this.getCuratorStyles(),
                styleState: this.styleState,
                displayStyleState: this.displayStyleState,
            };
        } else {
            return {
                styleState: this.styleState
            };
        }
    }

    toApi(): any {
        return {
            ...this.getCuratorStyles(),
            defaultReference: this.defaultReference ? this.defaultReference : StyleStateEnum.DEFAULT
        };
    }

    private getCuratorStyles(): any {
        return {
            backgroundColor: this.backgroundColor,
            padding: this.padding,
        };
    }
}
